<template>
    <div class="achievement">
        <div class="banner">
            <div class="ban-title inner">典型业绩</div>
        </div>

        <div class="cont">
            <!-- <div class="hospital-list inner">
                <div class="hosp-item" v-for="(item,i) in hospData" :key="i">
                    <img :src="item" alt="">
                </div>
            </div> -->

            <div class="project">
                <projectItem :projectData="projectData">
                </projectItem>
            </div>
        </div>
    </div>
</template>

<script>
import projectItem from './component/project-item.vue';
// import title from '@/mixins/title.js'

export default {
    head: {
        title: `典型业绩·中惠科技`,
    },
    name: '',
    // mixins:[title],
    components: { projectItem },
    data() {
        return {
            hospData: [
                '/images/achievement/h-1.png',
                '/images/achievement/h-2.png',
                '/images/achievement/h-3.png',
                '/images/achievement/h-4.png',
                '/images/achievement/h-5.png',
                '/images/achievement/h-6.png',
                '/images/achievement/h-7.png',
                '/images/achievement/h-8.png',
                '/images/achievement/h-9.png',
                '/images/achievement/h-10.png',
            ],

            projectData: [
                {
                    img: '/images/achievement/y-1.png',
                    title: '河北省相关部门招标投标公共服务平台',
                    // url: 'http://www.hebeieb.com/',
                    p1: [
                        '2017年2月，我公司负责研发和运维的河北省相关部门招标投标公共服务平台正式运营，实现了电子招标投标办法中相关的所有业务功能。截至目前，公共服务平台已经成为了河北省招标投标领域的枢纽网站，包含惠招标在内的15家三方平台都是以公共服务平台为基础，实现了有序运营。',
                    ],
                },
                {
                    img: '/images/achievement/y-2.png',
                    title: '河北省相关部门招标投标行政监督平台',
                    // url: 'http://hbdrc.hebei.gov.cn/ebas/index.htm',
                    p1: [
                        '依照横向到边，纵向到底的思路，2017年6月，我公司负责研发和运维的河北省相关部门招标投标行政监督平台建成并上线运行，河北省的省、市、县三级发改、住建、交通、水利等共500多个监管部门的工作开始由线下转为线上，实现了在线备案、监管，2018年获得国家公共资源交易创新奖。',
                    ],
                },

                {
                    img: '/images/achievement/y-3.png',
                    title: '河北省统一专家库',
                    // url: 'http://121.28.195.124:8888/pubsev/syslogin',
                    p1: [
                        '2018年9月，我公司负责研发的河北省统一专家库完成升级，正式上线，提供了交易平台和对接接口，打通了交易平台抽取、专家身份认证、评标报告电子签章、专家费等环节。系统包括了6大核心业务：专家入库考试，专家管理，专家抽取，专家评标，评审费用，专家评价。',
                    ],
                    p2: [],
                },
                {
                    img: '/images/achievement/y-4.png',
                    title: '邢建招投标交易平台',
                    // url: 'http://www.xtzjpt.com/',
                    p1: [
                        '邢台市建设工程交易中心（河北邢建建设工程交易有限公司）筹建的邢建招投标交易平台，于2020年4月30日正式上线。平台实现全流程电子招投标交易平台的全功能。已与中国招标投标公共服务平台、河北省招标投标公共服务平台实现了对接；平台于2020年4月26日取得电子招标投标系统认证证书（三星）；自上线起平稳运行至今。',
                    ],
                    p2: [],
                },

                {
                    img: '/images/achievement/y-5.png',
                    title: '河北省相关部门招投标信息管理平台',
                    // url: '',
                    p1: [
                        '河北省相关部门招投标信息管理平台是全河北省交通运输系统招投标信息的上报和发布平台，该平台以方便招标人和监管单位为目的，通过招标项目将招标人和监管单位有形的连接起来，大大提高了工作效率和管理效能。',
                    ],
                    p2: [],
                },
                {
                    img: '/images/achievement/y-6.png',
                    title: '河北相关部门数字化招标采购平台',
                    // url: 'https://www.jtsww.com/',
                    p1: [
                        '2020年伊始，河北相关部门启动新科技项目“基于微服务架构的数字化招标采购平台的研发”，经过前期大量的分析和调研工作，形成了详细的需求方案，定位构建高可用、高扩展、高性能的招标采购平台，同时构建多专业性平台，使之成为企业采购转型的关键基础和重要引擎，实现招标采购、非招标采购、商城采购所有采购方式全覆盖。同时，与相关部门各ERP系统进行了对接，并依据ISO20000设计了14个服务标准流程。2022年该项目正式进入研发阶段。由我公司负责。',
                    ],
                    p2: [],
                },
                {
                    img: '/images/achievement/y-7.png',
                    title: '高校数字化招标采购平台',
                    // url: '',
                    p1: [
                        '针对高校采购政策性强、预算严格、采购范围广、专业度高、采购周期长等特点。中惠科技从采购全过程管理出发，以“内控+采购”的形式搭建平台，紧跟政策，技术迭代，提升效率降低成本，彻底释放高校采购新动能。目前仅河北服务的高校就10余所，遍布河北各地市。+采购”的形式搭建平台，紧跟政策，技术迭代，提升效率降低成本，彻底释放高校采购新动能。目前仅河北服务的高校就10余所，遍布河北各地市。',
                    ],
                    p2: [],
                },
                {
                    img: '/images/achievement/y-8.png',
                    title: '医院数字化招标采购平台',
                    // url: '',
                    p1: [
                        '医院采购的难题主要在于没有对采购各个环节进行分类管理。中惠科技为各大医院量身定制了电子采购方案——',
                        '采购管理+代理管理+供应商管理+专家管理+资料管理+资产管理',
                        '，全链覆盖，各有侧重，实现全院采购无纸化，打造示范性标杆医院。目前已有多家医院通过我们的电子采购方案实现数字化管理。',
                    ],
                    p2: [],
                },
                {
                    img: '/images/achievement/y-9.png',
                    title: '大型国企数字化招标采购平台',
                    // url: 'http://yanyunyc.hbidding.com/',
                    p1: ['大型国企子公司众多，流程差异化，导致国企采购难以做到顺畅衔接，同时在采购项目需要进行审计的时候可能会出现数据缺失和流程繁琐等问题。'],
                    p2: [
                        '中惠科技围绕交易、管理、服务三大功能体系，推动数字赋能和制度重塑，贯通国企采购全流程：',
                        '预算立项→采购计划一线上采购→合同管理→电子档案管理→项目验收→费用结算',
                        '，目前交通、热力、石化、钢铁等多行业国企通过与我们深入合作，实现了全方位规范招采过程、改善招采质量、节省采购成本、提升多方协同效率。真正实现阳光招',
                    ],
                },
            ],
        };
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped>
.achievement {
    background-color: #fff;
    min-height: 1000px;
    .banner {
        height: 365px;
        background: url('/images/achievement/bg.png') no-repeat;
        background-position: center;
        background-color: #f8fcfe;
        .ban-title {
            font-size: 30px;
            font-weight: 600;
            padding-top: 58px;
        }
    }

    .cont {
        margin-top: -220px;
        .hospital-list {
            height: 180px;
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;
        }
    }

    .inner {
        width: 1200px;
        margin: 0 auto;
    }
}
</style>
